import template from './daily-closing.html';
import controller from './daily-closing.controller';
import './daily-closing.scss';

let DailyClosingComponent = {
  bindings: {},
  template,
  controller
};

export default DailyClosingComponent;



// WEBPACK FOOTER //
// ./src/app/pages/daily-closing/daily-closing.component.js